/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import { cvvAndPanScreens } from '../../screens/Card/constants';
import EnterAccountPassword from '../../screens/Card/EnterAccountPassword';

const ViewCvvAndPanModal = ({ hide, setPassword, getDetails, isLoadingDetails }) => {
  const [currentScreen, setCurrentScreen] = useState(cvvAndPanScreens.ACCOUNT_PASSWORD);

  const cvvAndPanFlow = useMemo(
    () => [
      {
        screen: cvvAndPanScreens.ACCOUNT_PASSWORD,
        component: (
          <EnterAccountPassword
            openScreen={setCurrentScreen}
            setPassword={setPassword}
            getDetails={getDetails}
            isLoadingDetails={isLoadingDetails}
          />
        ),
      },
    ],
    [setPassword, getDetails, isLoadingDetails]
  );

  const SelectedComponent = useMemo(
    () => cvvAndPanFlow.find((item) => item.screen === currentScreen).component,
    [cvvAndPanFlow, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal contentStyle={{ maxHeight: '25rem' }}>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

ViewCvvAndPanModal.propTypes = {
  hide: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  getDetails: PropTypes.func.isRequired,
  isLoadingDetails: PropTypes.bool.isRequired,
};

export default ViewCvvAndPanModal;
